import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CampaignService } from 'src/app/services/campaign.service';

@Component({
    selector: 'app-campaign-delete-modal',
    templateUrl: './campaign-delete-modal.component.html',
    styleUrls: ['./campaign-delete-modal.component.scss']
})
export class CampaignDeleteModalComponent implements OnInit {
    public campaignId: string;
    constructor(
        public dialog: MatDialog,
        private dialogRef: MatDialogRef<CampaignDeleteModalComponent>,
        private campaignService: CampaignService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.campaignId = data.campaignId;
    }

    ngOnInit(): void {}

    deleteCampaign(): void {
        this.campaignService.deleteCampaign(this.campaignId).subscribe(_ => {
            this.dialogRef.close();
        });
    }
}
